module.exports = __webpack_public_path__ + "img/code.6c7733dd.jpg";